var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.263 12.473V1.737H8.632V.789a.632.632 0 10-1.264 0v.948H.737v10.736h6.631v1.605l-2.62 2.23a.631.631 0 00.82.947l1.8-1.52v1.16a.632.632 0 001.264 0v-1.16l1.8 1.535c.114.098.26.152.41.152a.631.631 0 00.48-.212.631.631 0 00-.07-.89l-2.62-2.242v-1.604h6.631zM2 11.21V3h12v8.21H2zm8.043-5.59a2.504 2.504 0 01.445 1.937A2.526 2.526 0 118 4.579v2.526l2.043-1.484z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F_Presentation.bceda587.svg";
export { SvgFPresentation as ReactComponent };